import React from 'react';
import FAT32 from './FAT32.js';
import MSGBOX from './MSGBOX';
import ICONS from './ICONS';

function getFileOrFolder(path) {
    var parts = path == "" ? [] : path.split("\\");
    
    var currentObj = FAT32;
    var path = "";
    for (var i = 0; i < parts.length; i++) {
        if (currentObj.type != "directory") {
            throw "File is not directory";
        } else if (currentObj.children.hasOwnProperty(parts[i])) {
            currentObj = currentObj.children[parts[i]];
            if (currentObj.type == "link") {
                // Follow the link recursively
                currentObj = getFileOrFolder(currentObj.destination);
            }
            path = path + parts[i] + "\\";
        } else {
            if (i == 0) {
                throw new Error("Specified drive does not exist: " + path);
            } else {
                throw "File not found: " + path + parts[i];
            }
        }
    }

    return currentObj;
}

// the winapi is where applications make windows API calls
// most of the time it does this by changing WIN.
class WINAPI {
    constructor(win) {
        this.win = win;
        this.hwnd = 7466;
        this.foregroundHwnd = -1;

        this.hwndLayers = {};
        this.topLayer = 0;

        this.lastMousePosition = [0, 0];

        this.eventHooks = {};
    }

    GetFileInfo(lpFileName) {
        let info = getFileOrFolder(lpFileName);
        if (info.type == "link") {
            return this.GetFileInfo(info.destination);
        } else {
            return {
                name: info.displayName || lpFileName.split("\\").pop(),
                ...info,
                children: undefined
            };
        }
    }

    FindFile(lpFileName) {
        var obj = getFileOrFolder(lpFileName);
        if (obj.type != "directory") {
            throw "Not directory";
        }
        var result = [];
        for (var key in obj.children) {
            if (obj.children.hasOwnProperty(key)) {
                let orig = obj.children[key];
                var item = {
                    name: key,
                    ...orig,
                    children: undefined
                };
                if (item.type == "link") {
                    item.destination = obj.children[key].destination;
                    // Copy icon from destination
                    let destFile = this.GetFileInfo(item.destination);
                    item.icon16 = destFile.icon16;
                    item.icon32 = destFile.icon32;
                }
                result.push(item);
            }
        }
        return result;
    }

    OpenFile(lpFileName) {
        var obj = this.GetFileInfo(lpFileName);
        if (obj.type != "file") {
            throw "Cannot open filesystem object of type " + obj.type;
        }
        return obj.contents;
    }

    CreateProcess(lpApplicationName, lpCommandLine) {
        try {
            this.OpenFile(lpApplicationName)(lpCommandLine);
        } catch (e) {
            throw (lpApplicationName + " is not a valid win32 application.");
        }
    }

    CreateWindow(wndClass, extraProps) {
        var hwnd = this.hwnd;
        this.hwnd++;

        var props = Object.assign(extraProps || {}, {
            key: "window-" + hwnd,
            hwnd: hwnd,
            ref: (wnd) => {
                this.win.wndRef(hwnd, wnd);
            }
        });

        this.hwndLayers[hwnd] = this.topLayer;
        this.topLayer += 1;
        this.ResetWindowLayers();

        props.initialPositionX = props.initialPositionY = ((hwnd % 5) + 1) * 10;

        if (hwnd == 7466) {
            // First window
            if (window.innerWidth < 800) {
                // On mobile, starts maximized
                props.initialIsMaximized = true;
            } else {
                // On desktop, starts offset
                props.initialPositionX = window.innerWidth - 800 - Math.min(100, (window.innerWidth - 800) / 2);
                props.initialPositionY = window.innerHeight - 600 - 100;
            }
        }

        var wnd = React.createElement(wndClass, props, "");

        this.win.addWnd(hwnd, wnd);
        this.win.setState({ foregroundHwnd: hwnd });
        this.foregroundHwnd = hwnd;
        this.TriggerEvent("focus");
    }

    FindWindow(hwnd) {
        return this.win.wnds[hwnd];
    }

    GetActiveWindow() {
        return this.foregroundHwnd;
    }

    SetCursorVisible(visible) {
        if (this.cursor) {
            this.cursor.setCursorVisible(visible);
        }
    }

    SetActiveWindow(hwnd) {
        this.win.setState({
            foregroundHwnd: hwnd
        });
        this.foregroundHwnd = hwnd;
        
        // bring to top
        if (hwnd != -1) {
            this.hwndLayers[hwnd] = this.topLayer;
            this.topLayer += 1;
            this.ResetWindowLayers();
        }

        this.TriggerEvent("focus");
    }

    CloseWindow(hwnd) {
        delete this.hwndLayers[hwnd];
        this.win.removeWnd(hwnd);

        if(this.foregroundHwnd == hwnd) {
            var newForeground = -1;
            for (var hwnd2 in this.hwndLayers) {
                if (newForeground == -1 || this.hwndLayers[newForeground] < this.hwndLayers[hwnd2]) {
                    newForeground = hwnd2;
                }
            }
            if (newForeground != -1) {
                this.SetActiveWindow(newForeground);
            }
        }
    }

    GetDesktopWindow() {
        // menus and tooltips live in the overlay element
        return this.win.overlayElement;
    }

    GetCursorPos() {
        return this.lastMousePosition;
    }

    SetWinEventHook(event, handler) {
        if (!this.eventHooks[event]) {
            this.eventHooks[event] = [];
        }
        this.eventHooks[event].push(handler);
        return handler;
    }

    UnhookWinEvent(event, handler) {
        var arr = this.eventHooks[event];
        arr.splice(arr.indexOf(handler), 1);
    }

    TriggerEvent(event) {
        if (this.eventHooks[event]) {
            this.eventHooks[event].forEach(function (h) {
                h();
            });
        }
    }

    GetTopLayer() {
        return this.topLayer;
    }

    SetWindowLayer(hwnd, layer) {
        this.hwndLayers[hwnd] = layer;
    }

    GetWindowLayer(hwnd) {
        return this.hwndLayers[hwnd];
    }

    ClaimTopLayer() {
        this.topLayer += 1;
    }

    ResetWindowLayers() {
        // todo lower z-indexes so smallest is 0
    }

    SysCrashDump(idx) {
        let errbox = (title, msg) => this.MessageBox(title, msg, { "OK": () => {}}, ICONS.ERROR);

        let errors = [
            () => this.win.setState({ showBsod: true }),
            () => errbox("Insert Disk", "Please insert the disk labeled 'Windows 95 Disk4', and then click OK."),
            () => errbox("Windows Update", "An error occurred loading \"C:\\WINDOWS\\SYSTEM\\USER32.DLL\". The file may not have been installed or it has been corrupted."),
        ];
        
        errors[idx || Math.floor(Math.random() * errors.length)]();
    }

    // opens a file / directory with its assigned program
    ShellExecute(lpFile) {
        if (lpFile == "A:") {
            // Not formatted
            window.WINAPI.MessageBox("3½ Floppy (A:)",
                "The disk in drive A is not formatted.\n\nDo you want to format it now?",
                { "Yes": (() => window.WINAPI.SysCrashDump(0)), "No": () => null });
            return;
        }

        let info = this.GetFileInfo(lpFile);
        if (info.type == "directory") {

            // Open in Windows Explorer
            window.WINAPI.CreateProcess("C:\\WINDOWS\\Explorer.exe", lpFile);

        } else if (info.type == "file") {
            let extension = lpFile.split(".").pop();
            if (extension == "exe") {
                window.WINAPI.CreateProcess(lpFile);
            } else if (extension == "log" || extension == "txt") {
                window.WINAPI.CreateProcess("C:\\WINDOWS\\Notepad.exe", lpFile);
            } else {
                this.SysCrashDump(); // TODO MsgBox
            }
        } else {
            console.log("bad type " + info.type);
            this.SysCrashDump();
        }
    }

    // show shut down dialog
    InitiateShutdown() {
        //this.win.setState({ showShutdownVeil: true });
        setTimeout(() => {
            window.WINAPI.CreateProcess("C:\\WINDOWS\\Shutdown.exe");
        }, 500);
    }

    AbortShutdown() {
        this.win.setState({ showShutdownVeil: false });
    }

    InitiateSystemShutdown() {
        this.win.shutoff();
    }

    MessageBox(title, message, buttons, icon) {
        this.CreateWindow(MSGBOX, {
            title: title,
            message: message,
            buttons: buttons,
            icon: icon
        });
    }
}

export default WINAPI;



// WEBPACK FOOTER //
// ./src/walleris/WINAPI.js